export function getLocationsFromOrder(order: Gravitate.Order) {
  return [...(order?.loads ?? []), ...(order?.drops ?? [])].map((l) => ({
    label: l.location_name,
    value: l.location_id,
  }))
}
